import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuth } from '../context/AuthContext';
import Logo from './Logo';

const AppShell = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center"><Logo size="lg" /><p className="mt-3 text-sm text-slate-500">loading…</p></div>
    </div>
  );
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return (
    <div className="min-h-screen bg-slate-50 flex">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
};

export default AppShell;
